// import defaultSettings from '@/settings'

const title = "GTL Coach School";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
